import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

export const usePosts = (date?: string, category?: string, status?: string) =>
  useQuery({
    queryKey: ["posts", date ?? "all", category ?? "all", status ?? "all"],
    queryFn: () => api.posts.list({ date, category, status }),
    staleTime: 30_000,
  });

/**
 * Global count of pending-approval posts across all dates. Used for the
 * sidebar badge + dashboard banner. Refreshes every 30s so approving a
 * post elsewhere updates the count quickly.
 */
export const usePendingCount = () =>
  useQuery({
    queryKey: ["posts", "all", "all", "pending", "count"],
    queryFn: () => api.posts.list({ status: "pending" }).then((p) => p.length),
    refetchInterval: 30_000,
    staleTime: 20_000,
  });

export const usePost = (id: string | undefined) =>
  useQuery({
    queryKey: ["post", id],
    queryFn: () => api.posts.get(id!),
    enabled: Boolean(id),
  });

export const useSettings = () =>
  useQuery({
    queryKey: ["settings"],
    queryFn: api.settings.get,
    refetchInterval: 30_000,
  });
